import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Country} from '../../../../core/services/country/country';

export function healthCenterCountryValidator(control: AbstractControl): ValidationErrors | null {
  if (!(control.get('country')?.value instanceof Country)) {
    control.get('country')?.setErrors({incorrect: true});
  } else {
    control.get('country')?.setErrors(null);
  }

  return null;
}
